<template>
  <div v-if="!isListSearchEnable" class="position-sticky top-86x">
    <form
      class="job-search w-317x container container-primary my-15 px-0"
      @submit="onSubmitForSearchJob"
    >
      <div
        v-if="saveJobSearchResult == 'limited'"
        class="alert alert-success alert-dismissible fade show text-danger"
        role="alert"
      >
        保存できる条件の上限（10件）に達しています
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      <div
        v-if="saveJobSearchResult == 'success'"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        更新が正常に完了しました。
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      <div
        v-if="saveJobSearchResult == 'fail'"
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
      >
        更新が中断されました。
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      <div class="bg-blue-primary d-md-flex justify-content-center d-none rounded-top-8">
        <p class="m-2 text-white">検索条件</p>
      </div>
      <div class="bg-white-primary mx-3 mx-md-0">
        <div class="search-job-agent__body overflow-y-scroll">
          <div class="d-flex justify-content-center py-2 bg-silver-primary">
            <button
              type="button"
              class="btn bg-white d-flex justify-content-center align-items-center bg-silver-primary"
              @click="toggleConditionSearchStatus"
            >
              <img src="@/assets/images/icons/menu.svg" class="me-2" />
              <div class="flex-grow-1 size-12 lh-12 fw-medium color-blue-primary">
                保存した検索条件
              </div>
            </button>
          </div>
          <!-- Occupation -->
          <Occupation
            :occupations="occupationSelected"
            @open="onOpenModalOccupation"
            @remove="onRemoveOccupation"
          />
          <hr class="color-grey-primary opacity-100" />

          <!-- Prefecture -->
          <DesiredJob
            :prefectures="prefectureSelected"
            @open="onOpenModalPrefecture"
            @remove="onRemovePrefecture"
          />
          <hr class="color-grey-primary opacity-100" />

          <!-- annual-income -->
          <AnnualIncome
            :min-income="minIncomeSelected"
            :max-income="maxIncomeSelected"
            :incomes="props.incomes"
            @change-min="onChangeMinIncome"
            @change-max="onChangeMaxIncome"
          />
          <hr class="color-grey-primary opacity-100" />

          <!-- Industry -->
          <Industry
            :industries="industriesSelected"
            @open="onOpenModalIndustry"
            @remove="onRemoveIndusty"
          />
          <hr class="color-grey-primary opacity-100" />

          <!-- Skill -->
          <Skill :skills="skillSelected" @open="onOpenModalSkill" @remove="onRemoveSkill" />
          <hr class="color-grey-primary opacity-100" />

          <!-- Search word -->
          <div class="row mx-3 justify-content-start">
            <span class="form-label align-self-start size-12 p-0">フリーワード</span>
            <input
              v-model="searchWord"
              type="text"
              name="search_word"
              class="form-control size-14 bg-silver-primary input-primary"
              placeholder="例）○○○"
              @keydown.enter.prevent="search"
            />
          </div>
        </div>
        <hr class="color-grey-primary opacity-100" />

        <div class="job-search__footer justify-content-center pb-2 mb-3">
          <div class="text-center">
            <p class="size-12 fw-bold">
              この条件の求人数
              <span class="size-20 px-2">
                <vue3-autocounter
                  ref="counter"
                  :start-amount="0"
                  :end-amount="resultSearch"
                  :duration="1"
                  :autoinit="true"
                  @finished=""
                />
              </span>
              <span>件</span>
            </p>
          </div>
          <div class="d-flex justify-content-center">
            <Button variant="primary" button-style="filled" @click="() => onChangeResultSearch()">
              この条件で検索
            </Button>
          </div>

          <div class="h-48x d-flex justify-content-center mt-3">
            <div v-if="props.totalConditionSearch < 10">
              <Button
                variant="primary"
                button-style="outlined"
                data-bs-toggle="modal"
                data-bs-target="#saveJobCondition"
              >
                この条件を保存
              </Button>
            </div>
            <div v-else>
              <Button variant="primary" button-style="outlined" :disabled="true">
                この条件を保存
              </Button>
              <p class="text-danger size-12 text-center">
                保存できる条件の上限（10件）に達しています
              </p>
            </div>
          </div>

          <!-- Clear condition search -->
          <div
            class="text-center mt-1 mw-100 h-46x d-flex justify-content-center align-items-center"
          >
            <Button
              class="w-unset"
              variant="primary"
              button-style="no-border"
              icon="clear"
              @click="onClearConditionSearch"
            >
              条件をクリア
            </Button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div v-else class="position-relative">
    <div
      class="job-search list-condition-search position-absolute position-fixed w-317x"
      :style="{ top: isScrolled ? '100px' : '', bottom: isScrolledBottom ? '0' : '' }"
    >
      <div class="bg-blue-primary my-15 py-2 rounded-2 rounded-bottom-0">
        <div class="d-flex col-10 justify-content-center align-items-center">
          <p class="text-white m-0 ms-5">保存した検索条件</p>
        </div>
      </div>
      <div
        class="text-center bg-grey-05 py-2 border-start border-end border-white shadow-sm"
        @click="toggleConditionSearchStatus"
      >
        <img src="@/assets/images/icons/arrow-left-blue.svg" alt="Back icon" />
        <span class="ms-2 color-blue-primary cursor-pointer">条件設定に戻る</span>
      </div>
      <div class="list-job-container overflow-y-scroll bg-white mb-5 shadow-sm rounded-bottom-2">
        <div v-if="props.totalConditionSearch == 0">
          <p class="pt-3 text-center text-black-50 text-opacity-50">保存した検索条件はありません</p>
        </div>
        <div
          v-for="searchCondition in props.listConditionSearch"
          :key="searchCondition.id"
          class="border-bottom border-start-white border-end-white"
        >
          <div class="d-flex justify-content-between px-3">
            <div class="d-flex cursor-pointer" @click="onApplySearchCondition(searchCondition)">
              <img src="@/assets/images/icons/arrow_curved_left.svg" alt="Back icon" />
              <p class="text-black my-3 mx-2 truncate-text w-14" :title="searchCondition.title">
                {{ searchCondition.title }}
              </p>
            </div>
            <img
              src="@/assets/images/icons/trash_grey.svg"
              alt="Back icon"
              class="cursor-pointer"
              @click="onOpenModaConditionSearchConfirm(searchCondition.id, searchCondition.title)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="saveJobCondition" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="d-flex justify-content-end px-3 pt-3">
          <button role="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body p-0">
          <div class="d-flex justify-content-center p-0">
            <p class="m-2 fw-bold size-16">検索条件を保存</p>
          </div>
          <div class="row mx-3 justify-content-start px-3">
            <span class="form-label align-self-start size-12">検索条件名</span>
            <input
              v-model="title"
              type="text"
              name="title"
              class="form-control size-14 border-0 bg-silver-primary input-primary"
              maxlength="100"
            />
            <div class="d-flex justify-content-end counter text-black-50 size-10 mt-2">
              文字数： {{ title?.length }}
            </div>
          </div>
          <div class="h-48x d-flex justify-content-center my-4">
            <Button
              variant="primary"
              button-style="filled"
              :custom-size="true"
              :rounded="false"
              class="align-items-center justify-content-center d-flex h-48x w-285x rounded-24 py-3 size-12"
              data-bs-dismiss="modal"
              @click="onSubmitForSearchJob"
            >
              この条件を保存
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="confirmDeleteSearchConditionPC" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="d-flex justify-content-end px-3 pt-3">
          <button role="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body p-0">
          <div class="d-flex justify-content-center p-0">
            <h6 class="m-2 px-4">｢{{ titleItemSearch }}｣ を削除しますか？</h6>
          </div>
          <div
            class="d-flex flex-column-reverse flex-md-row gap-2 justify-content-center align-items-center my-4"
          >
            <Button
              variant="primary"
              button-style="outlined"
              :custom-size="true"
              :rounded="false"
              class="mw-184x h-36x w-15 size-12 rounded-5 d-flex justify-content-center align-items-center"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              キャンセル
            </Button>
            <Button
              variant="primary"
              button-style="filled"
              :custom-size="true"
              :rounded="false"
              class="mw-184x h-36x w-15 size-12 rounded-5 d-flex justify-content-center align-items-center"
              data-bs-dismiss="modal"
              @click="onDeleteSearchCondition(idItemSearch)"
            >
              削除する
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalBase
    ref="modalOccupations"
    element="modalOccupationsElement"
    title="職種を選ぶ"
    @addItems="addOccupations"
  >
    <template #body>
      <div id="occupation-accordion" class="accordion accordion-primary">
        <div v-for="occupation in props.occupations" :key="occupation.id" class="accordion-item">
          <div class="accordion-header px-3 py-2">
            <div class="flex-grow-1">
              <input
                :id="`occupation-item-input-${occupation.id}`"
                type="checkbox"
                class="form-check-input collapsed checkbox-primary-input w-1d5 h-1d5 mt-0"
                :checked="valuesOccupations.some((item) => item.id == occupation.id)"
                @change="(e) => onChooseOccupationCategory(occupation, e)"
              />
              <label
                class="form-check-label size-12 ms-3"
                :for="`occupation-item-input-${occupation.id}`"
              >
                {{ occupation.name }}
              </label>
            </div>
            <div
              v-show="occupation?.children && occupation?.children.length"
              class="accordion-button collapsed d-contents"
              data-bs-toggle="collapse"
              :data-bs-target="`#occupation-item-${occupation.id}-search`"
              aria-expanded="true"
              :aria-controls="`#occupation-item-${occupation.id}-search`"
            ></div>
          </div>
          <div
            :id="`occupation-item-${occupation.id}-search`"
            class="row mx-2 my-2 pe-0 accordion-collapse collapse"
          >
            <div
              v-for="children in occupation.children"
              :key="children.id"
              class="py-2 d-flex w-unset align-items-center accordion-body"
              :aria-labelledby="`occupation-${occupation.id}`"
            >
              <input
                :id="`occupation-item-input-${children.id}`"
                type="checkbox"
                class="form-check-input checkbox-primary-input w-1d5 h-1d5 d-flex flex-inherit mt-0"
                :checked="
                  valuesOccupations.some((item) => item.children.some((c) => c.id == children.id))
                "
                @click="onChooseOccupation(occupation, children)"
              />
              <label
                class="form-check-label size-12 ms-3"
                :for="`occupation-item-input-${children.id}`"
              >
                {{ children.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>

  <ModalBase
    ref="modalPrefecture"
    element="modalPrefectureElement"
    title="勤務地を選ぶ"
    @addItems="addPrefectures"
  >
    <template #body>
      <div class="py-24x px-40x d-flex gap-3 w-100 accordion__left">
        <div class="d-flex p-0 m-0 w-160x align-items-start">
          <div class="border rounded-8 border-1 border flex-grow-1 align-items-start">
            <div
              v-for="prefecture in prefectures"
              :key="prefecture.id"
              :class="`prefecture-item py-3 px-24x border-bottom cursor-pointer ${
                prefectureAccordionSelected === prefecture.id && 'accordion__left--active'
              }`"
              @click="prefectureAccordionSelected = prefecture.id"
            >
              {{ prefecture.name }}
            </div>
          </div>
        </div>
        <div class="accordion accordion-primary flex-grow-1">
          <div
            v-for="(children, index) in prefectureChildrens"
            id="prefecture-accordion"
            :key="children.id"
            :class="`accordion accordion-item accordion-primary border-grey-10 d-flex border flex-column ${
              prefectureChildrens && index !== prefectureChildrens.length - 1
                ? 'border-bottom-0'
                : ''
            }`"
          >
            <div class="accordion-header px-3 py-2">
              <div class="flex-grow-1">
                <input
                  :id="`prefecture-item-input-${prefectureAccordionSelected}-children-${children.id}`"
                  type="checkbox"
                  class="form-check-input collapsed checkbox-primary-input w-1d5 h-1d5 mt-0"
                  :checked="valuesPrefectures.some((item) => item.id == children.id)"
                  @change="onChangePrefecture(children)"
                />
                <label
                  class="form-check-label size-12 ms-3"
                  :for="`prefecture-item-input-${prefectureAccordionSelected}-children-${children.id}`"
                >
                  {{ children.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>

  <ModalBase
    ref="modalIndustry"
    element="modalIndustryElement"
    title="業種を追加する"
    @addItems="addIndustries"
  >
    <template #body>
      <div class="accordion accordion-primary">
        <div v-for="industry in props.industries" :key="industry.id" class="accordion-item">
          <div class="accordion-header px-3 py-2">
            <div class="flex-grow-1">
              <input
                :id="`industry-item-input-${industry.id}`"
                type="checkbox"
                class="form-check-input collapsed checkbox-primary-input w-1d5 h-1d5 mt-0"
                :checked="valuesIndustries.some((item) => item.id == industry.id)"
                @change="(e) => onChooseIndustryCategory(industry, e)"
              />
              <label
                class="form-check-label size-12 ms-3"
                :for="`industry-item-input-${industry.id}`"
              >
                {{ industry.name }}
              </label>
            </div>
            <div
              v-show="industry?.children && industry?.children.length"
              class="accordion-button collapsed d-contents"
              data-bs-toggle="collapse"
              :data-bs-target="`#industry-item-${industry.id}-search`"
              aria-expanded="true"
              :aria-controls="`#industry-item-${industry.id}-search`"
            ></div>
          </div>
          <div
            :id="`industry-item-${industry.id}-search`"
            class="row mx-2 my-2 pe-0 accordion-collapse collapse"
          >
            <div
              v-for="children in industry.children"
              :key="children.id"
              class="py-2 d-flex w-unset align-items-center accordion-body"
              :aria-labelledby="`industry-${industry.id}`"
            >
              <input
                :id="`industry-item-input-${children.id}`"
                type="checkbox"
                class="form-check-input checkbox-primary-input w-1d5 h-1d5 d-flex flex-inherit mt-0"
                :checked="
                  valuesIndustries.some((item) => item.children.some((c) => c.id == children.id))
                "
                @click="onChooseIndustry(industry, children)"
              />
              <label
                class="form-check-label size-12 ms-3"
                :for="`industry-item-input-${children.id}`"
              >
                {{ children.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>

  <ModalBase
    ref="modalSkills"
    element="modalSkillsElement"
    title="スキルを選ぶ"
    @addItems="addSkills"
  >
    <template #body>
      <div class="accordion accordion-primary">
        <div v-for="skill in props.skills" :key="skill.id" class="accordion-item">
          <div class="accordion-header px-3 py-2">
            <div class="flex-grow-1">
              <input
                :id="`skill-item-input-${skill.id}`"
                type="checkbox"
                class="form-check-input collapsed checkbox-primary-input w-1d5 h-1d5 mt-0"
                :checked="valueSkills.some((item) => item.id == skill.id)"
                @change="(e) => onChooseSkillCategory(skill, e)"
              />
              <label class="form-check-label size-12 ms-3" :for="`skill-item-input-${skill.id}`">
                {{ skill.name }}
              </label>
            </div>
            <div
              v-show="skill?.children && skill?.children.length"
              class="accordion-button collapsed d-contents"
              data-bs-toggle="collapse"
              :data-bs-target="`#skill-item-${skill.id}-search`"
              aria-expanded="true"
              :aria-controls="`#skill-item-${skill.id}-search`"
            ></div>
          </div>
          <div
            :id="`skill-item-${skill.id}-search`"
            class="row mx-2 my-2 pe-0 accordion-collapse collapse"
          >
            <div
              v-for="children in skill.children"
              :key="children.id"
              class="py-2 d-flex w-unset align-items-center accordion-body"
              :aria-labelledby="`skill-${skill.id}`"
            >
              <input
                :id="`skill-item-input-${children.id}`"
                type="checkbox"
                class="form-check-input checkbox-primary-input w-1d5 h-1d5 d-flex flex-inherit mt-0"
                :checked="
                  valueSkills.some((item) => item.children.some((c) => c.id == children.id))
                "
                @click="onChooseSkill(skill, children)"
              />
              <label class="form-check-label size-12 ms-3" :for="`skill-item-input-${children.id}`">
                {{ children.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script setup lang="ts">
import _ from 'lodash';
import { computed, nextTick, onMounted, PropType, ref, watchEffect, defineProps } from 'vue';
import { Collapse } from 'bootstrap';

import ModalBase from '@/components/common/ModalBase/index.vue';
import Occupation from '@/components/JobSearch/Occupation.vue';
import DesiredJob from '@/components/JobSearch/DesiredJob.vue';
import AnnualIncome from '@/components/JobSearch/AnnualIncome.vue';
import Industry from '@/components/JobSearch/Industry.vue';
import Skill from '@/components/JobSearch/Skill.vue';
import Button from '@/components/shared/button/Button.vue';
import { OccupationPrimary, OccupationThirdary } from '@/types/models/occupation';
import {
  PrefectureFifth,
  PrefectureFourth,
  PrefecturePrimary,
  PrefectureSecondary,
} from '@/types/models/prefecture';
import { IndustryType } from '@/types/models/industryType';
import { SkillsType } from '@/types/models/skill';
import { IncomePrimary } from '@/types/models/income';
import { cloneDeep } from 'lodash';
import Vue3Autocounter from 'vue3-autocounter';
import { deleteConditionJobSearch, getAgentJobs } from '@/apis/job.api';
import { saveJobSearchCondition } from '@/apis/candidate';
import { Modal } from 'bootstrap';
import { AGENT_SEARCH_PATH, CANDIDATE_LOGIN_PATH } from '@/constant/routers/path';
import router from '@/routers';
import { useRoute } from 'vue-router';
import { KANTO_ID } from '@/constant';
import { useAuthStore } from '@/stores/auth.store';

const props = defineProps({
  prefectures: {
    type: Array as PropType<PrefecturePrimary[]>,
    required: true,
  },
  occupations: {
    type: Array as PropType<OccupationPrimary[]>,
    required: true,
  },
  industries: {
    type: Array as PropType<IndustryType[]>,
    required: true,
  },
  skills: {
    type: Array as PropType<SkillsType[]>,
    required: true,
  },
  sort: {
    type: String,
    required: true,
  },
  incomes: {
    type: Array as PropType<IncomePrimary[]>,
    required: true,
  },
  listConditionSearch: {
    required: true,
  },
  totalConditionSearch: {
    type: Number,
    required: true,
  },
  initialTotalResult: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['searchJob', 'getListConditionSearch']);

const valuesPrefectures = ref<PrefecturePrimary[]>([]);
const valuesOccupations = ref<OccupationThirdary[]>([]);
const valuesIndustries = ref<IndustryType[]>([]);
const valueSkills = ref<SkillsType[]>([]);
const searchWord = ref<string | null>(null);

const saveJobSearchResult = ref<string | null>(null);
const isListSearchEnable = ref(false);
const isScrolled = ref(false);
const isScrolledBottom = ref(false);
const idItemSearch = ref(0);
const titleItemSearch = ref('');
const modalElement = ref();
const title = ref<string | null>(null);
const perPage = 30;
const route = useRoute();
const authStore = useAuthStore();

const prefectureSelected = ref<PrefectureFourth[]>([]);
const occupationSelected = ref<OccupationThirdary[]>([]);
const industriesSelected = ref<IndustryType[]>([]);
const skillSelected = ref<SkillsType[]>([]);
const minIncomeSelected = ref<number | null>(null);
const maxIncomeSelected = ref<number | null>(null);
const prefectureAccordionSelected = ref<number>(KANTO_ID);

const modalPrefecture = ref<InstanceType<typeof ModalBase> | null>(null);
const modalOccupations = ref<InstanceType<typeof ModalBase> | null>(null);
const modalIndustry = ref<InstanceType<typeof ModalBase> | null>(null);
const modalSkills = ref<InstanceType<typeof ModalBase> | null>(null);

const resultSearch = ref(0);

onMounted(async () => {
  authStore.checkAuthenticated();
  await getParamSearch();
  resultSearch.value = props.initialTotalResult;
  title.value = getCurrentDate();
});

watchEffect(() => {
  if (!props.prefectures.length || prefectureAccordionSelected.value) return;
  prefectureAccordionSelected.value = props.prefectures[0].id;
});

const prefectureChildrens = computed(() => {
  const prefecturesFound = props.prefectures.find(
    (prefecture: any) => prefecture.id === prefectureAccordionSelected.value
  );
  if (prefecturesFound) return prefecturesFound.children;
  return [];
});

const getCurrentDate = (): string => {
  const currentDate = new Date();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const time =
    String(currentDate.getHours()).padStart(2, '0') +
    ':' +
    String(currentDate.getMinutes()).padStart(2, '0') +
    ':' +
    String(currentDate.getSeconds()).padStart(2, '0');

  return currentDate.getFullYear() + '/' + month + '/' + day + ' ' + time;
};

const onOpenModalOccupation = (): void => {
  modalOccupations?.value?.onOpen();
};

const addOccupations = (): void => {
  occupationSelected.value = cloneDeep(valuesOccupations.value);
  search();
};

const onChooseOccupationCategory = (occupation: any, event: Event): void => {
  event.stopPropagation();

  const isCurrentlySelected = valuesOccupations.value.some((item) => item.id === occupation.id);

  if (!isCurrentlySelected) {
    const newOccupation = {
      id: occupation.id,
      name: occupation.name,
      children: [],
    };

    occupation.children.forEach((child: any) => {
      newOccupation.children.push({
        id: child.id,
        name: child.name,
      });
    });

    valuesOccupations.value.push(newOccupation);
  } else {
    const index = valuesOccupations.value.findIndex((item) => item.id === occupation.id);
    if (index !== -1) {
      valuesOccupations.value.splice(index, 1);
    }
  }

  // アコーディオンを開く
  const accordionId = `occupation-item-${occupation.id}-search`;
  const accordionElement = document.getElementById(accordionId);
  if (accordionElement) {
    const collapse = Collapse.getInstance(accordionElement) || new Collapse(accordionElement);
    if (!accordionElement.classList.contains('show')) {
      collapse.show();
    }
  }

  search();
};

const onChooseOccupation = (
  occupationCategory: OccupationThirdary,
  occupation: OccupationThirdary
): void => {
  if (_.find(valuesOccupations.value, { id: occupationCategory.id })) {
    selectedOccupation(occupationCategory, occupation);
  } else {
    valuesOccupations.value.push({
      id: occupationCategory.id,
      name: occupationCategory.name,
      children: [],
    });
    selectedOccupation(occupationCategory, occupation);
  }
};

const selectedOccupation = (
  occupationCategory: OccupationThirdary,
  occupation: OccupationThirdary
): void => {
  const occupationCategoryEntry = _.find(valuesOccupations.value, { id: occupationCategory.id });
  if (occupationCategoryEntry) {
    if (_.find(occupationCategoryEntry.children, { id: occupation.id })) {
      occupationCategoryEntry.children = _.reject(occupationCategoryEntry.children, {
        id: occupation.id,
      });
    } else {
      occupationCategoryEntry.children.push(occupation);
    }

    if (occupationCategoryEntry.children.length === 0) {
      valuesOccupations.value = _.reject(valuesOccupations.value, { id: occupationCategory.id });

      _.forEach(props.occupations, (item) => {
        if (item.id === occupationCategory.id) {
          item.selected = false;
        }
      });
    }
  }
};

const onRemoveOccupation = (occupationId: number): void => {
  valuesOccupations.value = valuesOccupations.value
    .map((item) => ({
      ...item,
      children: item.children.filter((child) => child.id !== occupationId),
    }))
    .filter((item) => item.children.length > 0);
  occupationSelected.value = cloneDeep(valuesOccupations.value);
  search();
};

const onOpenModalPrefecture = (): void => {
  modalPrefecture?.value?.onOpen();
};

const onChangePrefecture = (prefecture: PrefectureSecondary): void => {
  let checked = false;
  if (valuesPrefectures.value.find((item) => item.id == prefecture.id)) {
    valuesPrefectures.value = valuesPrefectures.value.filter((item) => prefecture.id !== item.id);
  } else {
    checked = true;
    valuesPrefectures.value.push({ id: prefecture.id, name: prefecture.name, cities: [] });
  }

  props.prefectures.map((item) => {
    item.children?.map((child) => {
      if (child.id == prefecture.id) {
        child.selected = checked;
      }
    });
  });
};

const onRemovePrefecture = (prefectureId: number): void => {
  valuesPrefectures.value = valuesPrefectures.value.filter((item) => {
    return item.id != prefectureId;
  });
  prefectureSelected.value = cloneDeep(valuesPrefectures.value);
  search();
};

const addPrefectures = (): void => {
  prefectureSelected.value = cloneDeep(valuesPrefectures.value);
  search();
};

const onChangeMinIncome = (minIncome: { value: number | null }): void => {
  minIncomeSelected.value = minIncome.value;
  search();
};

const onChangeMaxIncome = (maxIncome: { value: number | null }): void => {
  maxIncomeSelected.value = maxIncome.value;
  search();
};

const onOpenModalIndustry = (): void => {
  modalIndustry?.value?.onOpen();
};

const onChooseIndustryCategory = (industry: any, event: Event): void => {
  event.stopPropagation();

  const isCurrentlySelected = valuesIndustries.value.some((item) => item.id === industry.id);

  if (!isCurrentlySelected) {
    const newIndustry = {
      id: industry.id,
      name: industry.name,
      children: [],
    };

    industry.children.forEach((child: any) => {
      newIndustry.children.push({
        id: child.id,
        name: child.name,
      });
    });

    valuesIndustries.value.push(newIndustry);
  } else {
    const index = valuesIndustries.value.findIndex((item) => item.id === industry.id);
    if (index !== -1) {
      valuesIndustries.value.splice(index, 1);
    }
  }

  // アコーディオンを開く
  const accordionId = `industry-item-${industry.id}-search`;
  const accordionElement = document.getElementById(accordionId);
  if (accordionElement) {
    const collapse = Collapse.getInstance(accordionElement) || new Collapse(accordionElement);
    if (!accordionElement.classList.contains('show')) {
      collapse.show();
    }
  }

  search();
};

const onChooseIndustry = (industryCategory: IndustryType, industry: IndustryType): void => {
  if (_.find(valuesIndustries.value, { id: industryCategory.id })) {
    selectedIndustry(industryCategory, industry);
  } else {
    valuesIndustries.value.push({
      id: industryCategory.id,
      name: industryCategory.name,
      children: [],
    });
    selectedIndustry(industryCategory, industry);
  }
};

const selectedIndustry = (industryCategory: IndustryType, industry: IndustryType): void => {
  const industryCategoryEntry = _.find(valuesIndustries.value, { id: industryCategory.id });
  if (industryCategoryEntry) {
    if (_.find(industryCategoryEntry.children, { id: industry.id })) {
      industryCategoryEntry.children = _.reject(industryCategoryEntry.children, {
        id: industry.id,
      });
    } else {
      industryCategoryEntry.children.push(industry);
    }

    if (industryCategoryEntry.children.length === 0) {
      valuesIndustries.value = _.reject(valuesIndustries.value, { id: industryCategory.id });

      _.forEach(props.industries, (item) => {
        if (item.id === industryCategory.id) {
          item.selected = false;
        }
      });
    }
  }
};

const onRemoveIndusty = (industryId: number): void => {
  valuesIndustries.value = valuesIndustries.value
    .map((item) => ({
      ...item,
      children: item.children.filter((child) => child.id !== industryId),
    }))
    .filter((item) => item.children.length > 0);
  industriesSelected.value = cloneDeep(valuesIndustries.value);
  search();
};

const addIndustries = (): void => {
  industriesSelected.value = cloneDeep(valuesIndustries.value);
  search();
};

const onOpenModalSkill = (): void => {
  modalSkills?.value?.onOpen();
};

const onChooseSkillCategory = (skill: any, event: Event): void => {
  event.stopPropagation();

  const isCurrentlySelected = valueSkills.value.some((item) => item.id === skill.id);

  if (!isCurrentlySelected) {
    const newSkill = {
      id: skill.id,
      name: skill.name,
      children: [],
    };

    skill.children.forEach((child: any) => {
      newSkill.children.push({
        id: child.id,
        name: child.name,
      });
    });

    valueSkills.value.push(newSkill);
  } else {
    const index = valueSkills.value.findIndex((item) => item.id === skill.id);
    if (index !== -1) {
      valueSkills.value.splice(index, 1);
    }
  }

  // アコーディオンを開く
  const accordionId = `skill-item-${skill.id}-search`;
  const accordionElement = document.getElementById(accordionId);
  if (accordionElement) {
    const collapse = Collapse.getInstance(accordionElement) || new Collapse(accordionElement);
    if (!accordionElement.classList.contains('show')) {
      collapse.show();
    }
  }

  search();
};

const onChooseSkill = (skillCategory: SkillsType, skill: SkillsType): void => {
  if (_.find(valueSkills.value, { id: skillCategory.id })) {
    selectedSkill(skillCategory, skill);
  } else {
    valueSkills.value.push({ id: skillCategory.id, name: skillCategory.name, children: [] });
    selectedSkill(skillCategory, skill);
  }
};

const selectedSkill = (skillCategory: SkillsType, skill: SkillsType): void => {
  const skillCategoryEntry = _.find(valueSkills.value, { id: skillCategory.id });
  if (skillCategoryEntry) {
    if (_.find(skillCategoryEntry.children, { id: skill.id })) {
      skillCategoryEntry.children = _.reject(skillCategoryEntry.children, { id: skill.id });
    } else {
      skillCategoryEntry.children.push(skill);
    }

    if (skillCategoryEntry.children.length === 0) {
      valueSkills.value = _.reject(valueSkills.value, { id: skillCategory.id });

      _.forEach(props.skills, (item) => {
        if (item.id === skillCategory.id) {
          item.selected = false;
        }
      });
    }
  }
};

const onRemoveSkill = (skillId: number): void => {
  valueSkills.value = valueSkills.value
    .map((item) => ({ ...item, children: item.children.filter((child) => child.id !== skillId) }))
    .filter((item) => item.children.length > 0);
  skillSelected.value = cloneDeep(valueSkills.value);
  search();
};

const addSkills = (): void => {
  skillSelected.value = cloneDeep(valueSkills.value);
  search();
};

const onOpenModaConditionSearchConfirm = (id: number, title: string): void => {
  idItemSearch.value = id;
  titleItemSearch.value = title;

  nextTick(() => {
    const confirmDeleteElement: HTMLElement | null = document.getElementById(
      'confirmDeleteSearchConditionPC'
    );
    if (confirmDeleteElement) {
      modalElement.value = new Modal(confirmDeleteElement);
      modalElement.value.show();
    }
  });
};

const initialValuesConditionSearch = (): void => {
  searchWord.value = '';
  prefectureSelected.value = [];
  valuesPrefectures.value = [];
  occupationSelected.value = [];
  valuesOccupations.value = [];
  industriesSelected.value = [];
  valuesIndustries.value = [];
  skillSelected.value = [];
  valueSkills.value = [];
  minIncomeSelected.value = null;
  maxIncomeSelected.value = null;
};

const onClearConditionSearch = (): void => {
  initialValuesConditionSearch();
  search();
};

const toggleConditionSearchStatus = (): void => {
  if (!authStore.isAuthenticated) {
    window.location.href = CANDIDATE_LOGIN_PATH;
    return;
  }

  isListSearchEnable.value = !isListSearchEnable.value;
  saveJobSearchResult.value = '';
};

// !!!実際の挙動と関数名が逆
// onChangeResultSearchは、検索実行時に呼ばれる
// searchは、検索条件変更時に呼ばれる
const onChangeResultSearch = async (): Promise<void> => {
  const minIncome = props.incomes.find((income) => income.id === minIncomeSelected.value);
  const maxIncome = props.incomes.find((income) => income.id === maxIncomeSelected.value);

  const data = {
    keywords: searchWord.value,
    occupations: occupationSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    locations: prefectureSelected.value.map((item) => item.id),
    annual_min_income: minIncome?.display_amount ? getNumberIncome(minIncome.display_amount) : null,
    annual_max_income: maxIncome?.display_amount ? getNumberIncome(maxIncome.display_amount) : null,
    industries: industriesSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    skills: skillSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    sort_by: props.sort,
  };
  const params: Record<string, any> = {
    include: [
      'corporation',
      'prefectures',
      'hrc_skills',
      'hrc_job_types',
      'corporation.corporation_industries',
    ],
    'filter[have_hrc_job_types_any]': data.occupations,
    'filter[with_prefecture]': data.locations,
    'filter[have_corporation_industries_any]': data.industries,
    'filter[have_hrc_skills_any]': data.skills,
    'filter[contain_keywords_any]': data.keywords?.trim().split(/[\s　]+/) || [], // Split whitespace full-width or half-width
    sort: '-' + data.sort_by,
    'page[size]': perPage,
    'page[number]': undefined,
  };
  if (data.annual_min_income || data.annual_max_income) {
    params['filter[with_wage_range]'] = [data.annual_min_income, data.annual_max_income];
  }
  const response = await getAgentJobs(params);

  resultSearch.value = response.data.meta.total_records;
  emit('searchJob', response, data);
  if (window.scrollY > 0) document.documentElement.scrollTop = 0;
  const page = undefined;
  const paramsData = {
    keywords: searchWord.value || undefined,
    job_types: occupationSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    prefectures: prefectureSelected.value?.map((item) => item.id),
    city_ids: prefectureSelected.value.flatMap((item) => item.cities.map(({ id }) => id)),
    wage_min: minIncomeSelected.value || undefined,
    wage_max: maxIncomeSelected.value || undefined,
    industries: industriesSelected.value?.flatMap((item) => item.children.map((c) => c.id)),
    skills: skillSelected.value?.flatMap((item) => item.children.map((c) => c.id)),
    agent: true,
    page: page === 1 ? undefined : page,
  };

  // ルーターを更新する前にpage[size]パラメータを削除
  delete params['page[size]'];
  delete params['page[number]'];
  router.push({ path: AGENT_SEARCH_PATH, query: { ...route.query, ...paramsData } });
};

const onSubmitForSearchJob = async (): Promise<void> => {
  await emit('getListConditionSearch');
  if (props.totalConditionSearch > 10) {
    setTimeout(() => {
      saveJobSearchResult.value = '';
    }, 3000);
    return (saveJobSearchResult.value = 'limited');
  }
  const conditionSearchLocations: PrefectureFifth[] = [];
  prefectureSelected.value.forEach((item) => {
    if (item.cities.length <= 0) return conditionSearchLocations.push({ prefecture_id: item.id });
    item.cities.forEach((city) =>
      conditionSearchLocations.push({ prefecture_id: item.id, city_id: city.id })
    );
  });
  event?.preventDefault();
  const data = {
    platform: true,
    title: title.value || getCurrentDate(),
    keywords: searchWord.value,
    occupations: occupationSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    locations: conditionSearchLocations,
    annual_min_income_id: minIncomeSelected.value,
    annual_max_income_id: maxIncomeSelected.value,
    industries: industriesSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    skills: skillSelected.value.flatMap((item) => item.children.map((c) => c.id)),
  };
  const response = await saveJobSearchCondition(data);
  if (response.status === 200) {
    emit('getListConditionSearch');
    setTimeout(() => {
      saveJobSearchResult.value = '';
    }, 3000);
    saveJobSearchResult.value = 'success';
  } else {
    emit('getListConditionSearch');
    setTimeout(() => {
      saveJobSearchResult.value = '';
    }, 3000);
    saveJobSearchResult.value = 'fail';
  }
};

const onDeleteSearchCondition = async (id: number): Promise<void> => {
  const response = await deleteConditionJobSearch(id);
  if (response.status == 200) {
    emit('getListConditionSearch');
  }
};

const onApplySearchCondition = (searchCondition: any): void => {
  initialValuesConditionSearch();
  title.value = searchCondition?.title;
  searchWord.value = searchCondition?.candidate_saved_job_search_condition_freeword?.free_word;
  searchCondition.candidate_saved_job_search_condition_occupations.forEach((item) => {
    props.occupations.forEach((occupation) => {
      const occupationChild = occupation.children.find((child) => child.id === item.occupation_id);

      if (occupationChild) {
        onChooseOccupation(occupation, occupationChild);
        occupationSelected.value = cloneDeep(valuesOccupations.value);
      }
    });
  });
  const prefectureIds = [
    ...new Set(
      searchCondition.candidate_saved_job_search_condition_locations.map(
        (item) => item.prefecture_id
      )
    ),
  ];
  const cityIds = [
    ...new Set(
      searchCondition.candidate_saved_job_search_condition_locations.map((item) => item.city_id)
    ),
  ];
  prefectureIds.forEach((id) => {
    const prefecture = props.prefectures.find((prefecture) =>
      prefecture.children.some((child) => child.id === id)
    );
    if (prefecture) {
      const prefectureChild = prefecture.children.find((child) => child.id === id);
      const cities = [];

      cityIds
        .filter((item) => item !== null)
        .forEach((cityId) => {
          const matchingCity = [
            ...prefectureChild.main_cities,
            ...prefectureChild.extra_cities,
          ].find((city) => city.id === cityId);

          if (matchingCity) {
            cities.push(matchingCity);
          }
        });

      valuesPrefectures.value.push({
        id: prefectureChild.id,
        name: prefectureChild.name,
        cities: cities,
      });
      prefectureSelected.value = cloneDeep(valuesPrefectures.value);
    }
  });
  minIncomeSelected.value = searchCondition.annual_min_income_id;
  maxIncomeSelected.value = searchCondition.annual_max_income_id;
  searchCondition.candidate_saved_job_search_condition_industries.forEach((item) => {
    props.industries.forEach((industry) => {
      const industryChild = industry.children?.find((child) => child.id === item.industry_id);

      if (industryChild) {
        onChooseIndustry(industry, industryChild);
        industriesSelected.value = cloneDeep(valuesIndustries.value);
      }
    });
  });
  searchCondition.candidate_saved_job_search_condition_skills.forEach((item) => {
    props.skills.forEach((skill) => {
      const skillChild = skill.children.find((child) => child.id === item.skill_id);

      if (skillChild) {
        onChooseSkill(skill, skillChild);
        skillSelected.value = cloneDeep(valueSkills.value);
      }
    });
  });
  search();
  onChangeResultSearch();
  toggleConditionSearchStatus();
};

// !!!実際の挙動と関数名が逆
// onChangeResultSearchは、検索実行時に呼ばれる
// searchは、検索条件変更時に呼ばれる
const search = async (): Promise<void> => {
  const minIncome = props.incomes.find((income) => income.id === minIncomeSelected.value);
  const maxIncome = props.incomes.find((income) => income.id === maxIncomeSelected.value);

  const data = {
    keywords: searchWord.value,
    occupations: occupationSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    locations: prefectureSelected.value.map((item) => item.id),
    annual_min_income: minIncome?.display_amount ? getNumberIncome(minIncome.display_amount) : null,
    annual_max_income: maxIncome?.display_amount ? getNumberIncome(maxIncome.display_amount) : null,
    industries: industriesSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    skills: skillSelected.value.flatMap((item) => item.children.map((c) => c.id)),
  };

  const params: Record<string, any> = {
    include: [
      'corporation',
      'prefectures',
      'hrc_skills',
      'hrc_job_types',
      'corporation.corporation_industries',
    ],
    'filter[have_hrc_job_types_any]': data.occupations,
    'filter[with_prefecture]': data.locations,
    'filter[have_corporation_industries_any]': data.industries,
    'filter[have_hrc_skills_any]': data.skills,
    'filter[contain_keywords_any]': data.keywords?.trim().split(/[\s　]+/) || [], // Split whitespace full-width or half-width
    'page[size]': 0, // カウント取得時はデータ本体を取得しない
    'page[number]': 1,
  };
  if (data.annual_min_income || data.annual_max_income) {
    params['filter[with_wage_range]'] = [data.annual_min_income, data.annual_max_income];
  }

  const response = await getAgentJobs(params);
  resultSearch.value = response.data.meta.total_records;
};

const getNumberIncome = (income: string): number | null => {
  const numberRegex = /\d+/;
  const match = income.match(numberRegex);

  if (match) {
    const number = parseInt(match[0], 10);
    return number;
  }
  return null;
};

const getParamSearch = async (): Promise<void> => {
  if (Object.keys(route.query).length === 0) return search();
  initialValuesConditionSearch();

  searchWord.value = route.query.keywords;
  title.value = route.query.title || getCurrentDate();
  getOccupations();
  getDesireLocation();
  getAnnualIncome();
  getIndustries();
  getSkills();
};

const getDesireLocation = (): void => {
  if (route.query.prefectures || route.query['prefectures[]']) {
    let prefectureIds: any;
    if (route.query.prefectures) {
      prefectureIds = Array.isArray(route.query.prefectures)
        ? route.query.prefectures
        : [route.query.prefectures];
    } else {
      prefectureIds = Array.isArray(route.query['prefectures[]'])
        ? route.query['prefectures[]']
        : [route.query['prefectures[]']];
    }

    [...new Set(prefectureIds)].forEach((id) => {
      const prefecture = props.prefectures.find((prefecture) =>
        prefecture.children.some((child) => child.id.toString() == id)
      );
      if (prefecture) {
        const prefectureChild = prefecture.children.find((child) => child.id.toString() == id);
        const cities = [];

        if (route.query.city_ids || route.query['cities[]']) {
          let cityIds: any;
          if (route.query.city_ids) {
            cityIds = Array.isArray(route.query.city_ids)
              ? route.query.city_ids
              : [route.query.city_ids];
          } else {
            cityIds = Array.isArray(route.query['cities[]'])
              ? route.query['cities[]']
              : [route.query['cities[]']];
          }

          cityIds.forEach((cityId) => {
            const matchingCity = [
              ...prefectureChild.main_cities,
              ...prefectureChild.extra_cities,
            ].find((city) => city.id.toString() == cityId);

            if (matchingCity) {
              cities.push(matchingCity);
            }
          });
        }

        valuesPrefectures.value.push({
          id: prefectureChild.id,
          name: prefectureChild.name,
          cities: cities,
        });
        prefectureSelected.value = cloneDeep(valuesPrefectures.value);
      }
    });
  }
};

const getOccupations = (): void => {
  if (route.query.job_types || route.query['job_types[]']) {
    let occupationIds: any;
    if (route.query.job_types) {
      occupationIds = Array.isArray(route.query.job_types)
        ? route.query.job_types
        : [route.query.job_types];
    } else {
      occupationIds = Array.isArray(route.query['job_types[]'])
        ? route.query['job_types[]']
        : [route.query['job_types[]']];
    }

    occupationIds.forEach((id) => {
      props.occupations.forEach((occupation) => {
        const occupationChild = occupation.children.find((child) => child.id.toString() == id);

        if (occupationChild) {
          onChooseOccupation(occupation, occupationChild);
          occupationSelected.value = cloneDeep(valuesOccupations.value);
        }
      });
    });
  }
};

const getAnnualIncome = (): void => {
  const minIncomeId = route.query.wage_min;
  const maxIncomeId = route.query.wage_max;

  const minIncome = props.incomes.find((income) => income.id.toString() == minIncomeId);
  const maxIncome = props.incomes.find((income) => income.id.toString() == maxIncomeId);

  if (minIncome) {
    minIncomeSelected.value = minIncome.id;
  }
  if (maxIncome) {
    maxIncomeSelected.value = maxIncome.id;
  }
};

const getIndustries = (): void => {
  if (route.query.industries || route.query['industries[]']) {
    let industriesId: any;
    if (route.query.industries) {
      industriesId = Array.isArray(route.query.industries)
        ? route.query.industries
        : [route.query.industries];
    } else {
      industriesId = Array.isArray(route.query['industries[]'])
        ? route.query['industries[]']
        : [route.query['industries[]']];
    }

    industriesId.forEach((id) => {
      props.industries.forEach((industry) => {
        const industryChild = industry.children.find((child) => child.id.toString() == id);

        if (industryChild) {
          onChooseIndustry(industry, industryChild);
          industriesSelected.value = cloneDeep(valuesIndustries.value);
        }
      });
    });
  }
};

const getSkills = (): void => {
  if (route.query.skills || route.query['skills[]']) {
    let skillIds: any;
    if (route.query.skills) {
      skillIds = Array.isArray(route.query.skills) ? route.query.skills : [route.query.skills];
    } else {
      skillIds = Array.isArray(route.query['skills[]'])
        ? route.query['skills[]']
        : [route.query['skills[]']];
    }

    skillIds.forEach((id) => {
      props.skills.forEach((skill) => {
        const skillChild = skill.children.find((child) => child.id.toString() == id);

        if (skillChild) {
          onChooseSkill(skill, skillChild);
          skillSelected.value = cloneDeep(valueSkills.value);
        }
      });
    });
  }
};
</script>
